import * as React from "react";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";
import { ISymbolStore } from "../../stores/symbolStore";
import "./SymbolSelectSimple.scss";

interface AppProps {
    symbolStore?: ISymbolStore;
    symbolSelect?: ISymbolSelect;
}

interface ISymbolSelect {
    symbols: string[];
}

interface ISymbolOption {
    text: string;
    value: string;
    checked: boolean;
}

@inject( "symbolStore")
@observer
export default class SymbolSelectSimple extends React.Component<AppProps> {
  
    getSymbolPairFormatted(symbol: string): string{
        var snds = this.props.symbolStore.symbolNameDetails.filter(snd => snd.symbol == symbol);
        return snds.length > 0 ? snds[0].pair : symbol;
    }       

    @computed get symbols(): ISymbolOption[] {
        return this.props.symbolSelect.symbols
        .map(s => {
            return {
                text: this.getSymbolPairFormatted(s),
                value: s,
                checked: true
            };
        });             
    }
 
    changeSymbol(symbol: string, checked: boolean): void {
        if (checked) {
            this.props.symbolSelect.symbols.push(symbol);            
        } else {
            this.props.symbolSelect.symbols = this.props.symbolSelect.symbols.filter(s => s != symbol);
        }
    }   

    render() {
        return (
            <div className="symbol-select-simple-container" >                
                <div className="symbol-select-menu">
                {
                    this.symbols.map(s => {
                        return (
                            <div key={s.value} className="symbol-select-symbol">
                                <input type="checkbox" checked={s.checked} onChange={() => this.changeSymbol(s.value, !s.checked)} />
                                <span>{s.text}</span>
                            </div>                           
                                )
                    })
                }
                </div>
            </div>
        );
    }
}